import React from "react";
import { Header, Icon, Dimmer } from "semantic-ui-react";
import { NavLink } from "react-router-dom";

const NotFound = () => (
  <Dimmer active className={"pageDimmer"} style={{ "z-index": "30" }}>
    <Header as="h2" icon style={{ color: "#fdfdfd" }}>
      <Icon name="dont" />
      These are not the droids you are looking for.
      <Header.Subheader style={{ color: "#fdfdfd" }}>
        <NavLink to="/">Head back to the site.</NavLink>
      </Header.Subheader>
    </Header>
  </Dimmer>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/scenes/notFound/NotFound.js